import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CustomersQueryVariables = GraphQLTypes.Exact<{
  searchContains?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type CustomersQueryResult = { __typename?: 'Query' } & {
  customers?: GraphQLTypes.Maybe<
    { __typename?: 'CustomersCustomerTypeConnection' } & {
      nodes?: GraphQLTypes.Maybe<
        Array<
          GraphQLTypes.Maybe<
            { __typename?: 'CustomersCustomerType' } & Pick<
              GraphQLTypes.CustomersCustomerType,
              'isDivision' | 'isParent' | 'name' | 'uuid'
            > & {
                account?: GraphQLTypes.Maybe<
                  { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName' | 'type'> & {
                      businessUnits: Array<
                        { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'> & {
                            label?: GraphQLTypes.Maybe<
                              { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>
                            >;
                          }
                      >;
                      label?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>
                      >;
                    }
                >;
                division?: GraphQLTypes.Maybe<{ __typename?: 'Division' } & Pick<GraphQLTypes.Division, 'name'>>;
              }
          >
        >
      >;
    }
  >;
};

export const CustomersQueryDocument = gql`
  query customersQuery($searchContains: String) {
    customers(searchContains: $searchContains, paginated: false) {
      nodes {
        account {
          businessUnits {
            id
            label {
              long
            }
          }
          id
          label {
            long
          }
          tradingName
          type
        }
        division {
          name
        }
        isDivision
        isParent
        name
        uuid
      }
    }
  }
`;
